import { SimpleNotifications } from '@vimeo/cloud-live/components/shared/general/SimpleNotifications';
import { useInteractionToolsConfigUpdater } from '@vimeo/live-core/tracking/hooks';

import { InteractionToolsAmbientEmbedSignaling } from './InteractionToolsAmbientEmbedSignaling';
import { InteractionToolsResponsiveScaling } from './InteractionToolsResponsiveScaling';

/**
 * Ambient component to manage globals in interaction tools.
 */
export function InteractionToolsAmbient() {
  useInteractionToolsConfigUpdater();

  return (
    <>
      <InteractionToolsResponsiveScaling />
      <InteractionToolsAmbientEmbedSignaling />
      <SimpleNotifications />
    </>
  );
}
